import { subscriptionActionTypes as actionTypes } from "../../ActionTypes/Voss/subscriptionActionTypes";

const initialState = {
}
export default function SubscriptionReducer(state = { ...initialState }, action) {

    let newState;

    switch (action.type) {
        case actionTypes.STORE_SUBSCRIPTION:
            newState = {subscription: action.data}
            break;
        case actionTypes.STORE_SUBSCRIPTION_PRODUCT_GROUPS:
            newState = {subscriptionProductGroups: action.data};
            break;
        case actionTypes.STORE_SUBSCRIPTION_LICENSES:
            newState = {subscriptionLicenses: action.data};
            break;
        case actionTypes.STORE_AVAILABLE_MIGRATION:
            newState = {availableMigration: action.data};
            break;
        case actionTypes.CLEAR:
            delete state[action.key];
            break;
        case actionTypes.CLEAR_SUBSCRIPTION:
            return {...initialState}
        default:
            return state;
    }

    if (newState)
        return Object.assign({}, state, newState)

    return state;
}